import styled from "styled-components";

export const HealthContainer = styled.div`
  background: linear-gradient(135deg, ${props => props.theme.colors.gray[600]} 0%, ${props => props.theme.colors.gray[700]} 100%);
  border-radius: 8px;
  padding: 20px;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`;

export const HealthHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const HealthStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  backdrop-filter: blur(10px);
`;

export const StatusDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.$isRunning ? props.theme.colors.success : props.theme.colors.danger};
  box-shadow: 0 0 8px ${props => props.$isRunning ? props.theme.colors.success : props.theme.colors.danger};
  animation: ${props => props.$isRunning ? 'pulse 2s infinite' : 'none'};
  
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

export const HealthBody = styled.div`
  display: flex;
  gap: 30px;
  
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 15px;
  }
`;

export const HealthMetric = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  
  label {
    font-size: 12px;
    opacity: 0.9;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  span {
    font-size: 24px;
    font-weight: 700;
  }
`;

export const LastUpdate = styled.div`
  margin-top: 10px;
  font-size: 12px;
  opacity: 0.8;
  text-align: right;
`;

export const LoadingHealth = styled.div`
  background: linear-gradient(135deg, ${props => props.theme.colors.gray[600]} 0%, ${props => props.theme.colors.gray[700]} 100%);
  border-radius: 8px;
  padding: 20px;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  text-align: center;
  
  svg {
    animation: spin 1s linear infinite;
  }
  
  p {
    margin-top: 10px;
    font-size: 14px;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

export const ErrorHealth = styled.div`
  background-color: ${props => props.theme.colors.danger};
  border-radius: 8px;
  padding: 20px;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  
  h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 600;
  }
  
  p {
    margin: 0;
    font-size: 14px;
    opacity: 0.9;
  }
`;
